import PropTypes from 'prop-types';
import React from 'react';
import { Fragment } from 'react';

const SimpleCardItem = (props) => {
  return <Fragment>{props.children}</Fragment>;
};

SimpleCardItem.propTypes = {
  children: PropTypes.any
};

export default SimpleCardItem;
